<p-fileUpload #fileUpload [customUpload]="true" [multiple]="true" chooseLabel="Select" [accept]="acceptedFileTypes" chooseIcon="none" chooseStyleClass="p-button-secondary" uploadIcon="none" uploadStyleClass="p-button-secondary"
    i18n-chooseLabel="@@filestore-upload-choose-label" uploadLabel="Upload"
    i18n-uploadLabel="@@filestore-upload-upload-label" [showCancelButton]="false" (uploadHandler)="doUpload($event)"
    (onSelect)="onSelect($event)" >
    <ng-template pTemplate="toolbar">
        <span class="text-right" *ngIf="files.length>0 && !uploadStatus.running">
            <p-button label="Remove all" i18n-label="@@filestore-upload.buttons.remove-all" (onClick)="onRemoveAll()"
                severity="secondary" [outlined]="true" styleClass="mt-2"></p-button>
        </span>
    </ng-template>
    <ng-template let-file pTemplate="file">
        <div class="p-fileupload-row">
            <div *ngIf="isImage(file)"><img [src]="file.objectURL" [width]="50" /></div>
            <div class="p-fileupload-filename">{{file.name}}</div>
            <div>{{file.size | formatFileSize:false}}</div>
            <div *ngIf="uploadStatus.details[file.name]?.complete">
                <ng-container *ngIf="!uploadStatus.running">
                    <i class="far fa-check " style="font-size: 2rem" [ngStyle]="{color:'var(--green-500)'}"
                        *ngIf="uploadStatus.details[file.name].error == null"></i>
                    <i class="far p-error" style="font-size: 2rem"
                        *ngIf="uploadStatus.details[file.name]?.error!=null"></i>
                </ng-container>
            </div>
            <div *ngIf="!uploadStatus.running">
                <p-button (onClick)="onRemove(file)" icon="far fa-trash" severity="danger"></p-button>
            </div>
        </div>
        <p-messages severity="warn" *ngIf="file.exists">
            <ng-template pTemplate>
               <div i18n="@@filestore-upload.fileexist">This file already exists and will be overwritten.</div>
            </ng-template>
        </p-messages>
        <p-messages severity="error" *ngIf="uploadStatus.details[file.name]?.message">
            <ng-template pTemplate>
                {{uploadStatus.details[file.name].message}}
            </ng-template>
        </p-messages>
        <div style="position: relative;height:20px; margin-bottom: 20px;" *ngIf="uploadStatus.details[file.name]  && uploadStatus.details[file.name].error ==null">
            <p-progressBar [value]="uploadStatus.details[file.name]?.progress" [style]="{'height': '20px'}">
            </p-progressBar>
        </div>
    </ng-template>
    <ng-template pTemplate="content" let-files>
        <div class="card" *ngIf="files.length==0">
            <div class="flex flex-wrap align-items-center justify-content-center card-container">
                <p class="font-italic" i18n="@@filestore-upload.empty">Please add one or more files...</p>
            </div>
        </div>
    </ng-template>

</p-fileUpload>